import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CmdbPermissions } from 'src/app/util/interfaces/cmdbPermissions';

@Injectable({
	providedIn: 'root',
})
export class CmdbPermissionsService {
	private cmdbPermissions: CmdbPermissions[] = [
		{ permission: 'cmdb_access_points_editar', label: 'lbl_cmdb_access_point' },
		{ permission: 'cmdb_applications_editar', label: 'lbl_geral_alicacao' },
		{ permission: 'cmdb_backups_editar', label: 'lbl_projetos_politica_backup' },
		{ permission: 'cmdb_colocations_editar', label: 'lbl_cmdb_colocation' },
		{ permission: 'cmdb_data_bases_editar', label: 'lbl_geral_banco_dados' },
		{ permission: 'cmdb_dsl_editar', label: 'lbl_cmdb_dsl' },
		{ permission: 'cmdb_extensions_editar', label: 'lbl_geral_ramal' },
		{ permission: 'cmdb_firewalls_editar', label: 'lbl_cmdb_firewall' },
		{ permission: 'cmdb_hubs_editar', label: 'lbl_cmdb_hub' },
		{ permission: 'cmdb_internets_editar', label: 'lbl_asset_banda_internet' },
		{ permission: 'cmdb_itservices_editar', label: 'lbl_cmdb_itservices' },
		{ permission: 'cmdb_licenses_editar', label: 'lbl_cmdb_licenca' },
		{ permission: 'cmdb_links_editar', label: 'lbl_cmdb_type_link' },
		{ permission: 'cmdb_maintenance_contracts_editar', label: 'lbl_asset_contrato_manutencao' },
		{ permission: 'cmdb_miscelaneous_editar', label: 'lbl_cmdb_miscellaneous' },
		{ permission: 'cmdb_network_cables_editar', label: 'lbl_geral_ponto_rede' },
		{ permission: 'cmdb_peripheral_editar', label: 'lbl_asset_peripheral' },
		{ permission: 'cmdb_printers_editar', label: 'lbl_asset_impressora' },
		{ permission: 'cmdb_racks_editar', label: 'lbl_cmdb_rack' },
		{ permission: 'cmdb_routers_editar', label: 'lbl_asset_roteador' },
		{ permission: 'cmdb_scanners_editar', label: 'lbl_cmdb_scanner' },
		{ permission: 'cmdb_server_class_editar', label: 'lbl_asset_servidor' },
		{ permission: 'cmdb_servers_editar', label: 'lbl_asset_servidor' },
		{ permission: 'cmdb_storage_usage_editar', label: 'lbl_asset_inventario_storage' },
		{ permission: 'cmdb_storages_editar', label: 'lbl_cmdb_storage' },
		{ permission: 'cmdb_switches_editar', label: 'lbl_cmdb_switch' },
		{ permission: 'cmdb_tape_drives_editar', label: 'lbl_asset_inidade_fita' },
		{ permission: 'cmdb_tapes_editar', label: 'lbl_asset_fita' },
		{ permission: 'cmdb_telefonia_editar', label: 'lbl_cmdb_telefonia' },
		{ permission: 'cmdb_tpgs_editar', label: 'lbl_asset_conexao_tpg' },
		{ permission: 'cmdb_vpn_cards_editar', label: 'lbl_asset_cartao_vpn' },
		{ permission: 'cmdb_workstations_editar', label: 'lbl_asset_micro' },
	];

	getCmdbPermissions(): Observable<CmdbPermissions[]> {
		return of(this.cmdbPermissions);
	}
}
